import { HttpService, Repository, RepositoryBase, Tags, Weaver } from '@skylab-shared/core';
import { KsefSendParametersDTO, KsefSendParametersModel } from '@skylab-shared/dataModel';
import { pickBy } from '@skylab-shared/utils';
import { KsefSendParametersBO } from './ksef-send-parameters.bo';

@Repository({
	boType: KsefSendParametersBO,
	apiController: {
		base: 'system/ksef/send-parameters',
		tags: [Tags.Api]
	},
	dto: {
		get: KsefSendParametersDTO,
		update: KsefSendParametersDTO
	}
})
export class KsefSendParametersRepositoryBase extends RepositoryBase<KsefSendParametersBO, KsefSendParametersModel, KsefSendParametersDTO, KsefSendParametersDTO> {
	public constructor(
		private readonly weaver: Weaver,
		$http: HttpService,
	) {
		super($http);
	}

	protected createBO(): KsefSendParametersBO {
		return new KsefSendParametersBO(this.weaver);
	}

	protected async preparePlainObjectAsync(model: KsefSendParametersModel): Promise<KsefSendParametersDTO> {
		return {
			version: model.version,
			sendDocumentNote: model.sendDocumentNote,
			sendWzNumbers: model.sendWzNumbers,
            sendBarCodeAsGTIN: model.sendBarCodeAsGTIN,
            sendSymbolAsIndeks: model.sendSymbolAsIndeks,
			documentTemplateSendMode: model.documentTemplateSendMode,
			defaultDocumentType: model.defaultDocumentType
		};
	}

	protected async fromPlainObjectAsync(item: KsefSendParametersDTO): Promise<KsefSendParametersModel> {
		const converted = new KsefSendParametersModel(pickBy<KsefSendParametersModel>({
			id: item.id,
			version: item.version,
			sendDocumentNote: item.sendDocumentNote,
			sendWzNumbers: item.sendWzNumbers,
            sendBarCodeAsGTIN: item.sendBarCodeAsGTIN,
            sendSymbolAsIndeks: item.sendSymbolAsIndeks,
			documentTemplateSendMode: item.documentTemplateSendMode,
			defaultDocumentType: item.defaultDocumentType
		}, val => val !== void 0));

		return converted;
	}
}
